/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Assign_SnoozeInputs */



/**
* | output |
* | --- |
* | "Assign & snooze" |
*
* @param {Pricing_Compare_Assign_SnoozeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_assign_snooze = /** @type {((inputs?: Pricing_Compare_Assign_SnoozeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Assign_SnoozeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначение и откладывание")
	return /** @type {LocalizedString} */ ("Assign & snooze")
});